module.exports = __webpack_public_path__ + "img/leftList1.b81ad754.svg";